export default {"src":"/_next/static/media/library-books.5eff62ad.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};